import React from 'react';
import { useParams } from 'react-router-dom';
import StaffLayout from '../../components/StaffLayout';
import Receipt from '../../components/Receipt';
import { useAuth } from '../../context/AuthContext';
import { usePaymentResource } from '../../hooks/usePaymentResource';

export default function MerchantReceiptPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const { data, error, loading } = usePaymentResource(`/merchant/receipts/${id}`);
  return <StaffLayout>{loading ? <p data-testid="merchant-receipt-loading">Loading receipt…</p> : error ? <p data-testid="merchant-receipt-error" role="alert" className="text-rose-700">{error}</p> : data && <Receipt tx={data} shopName={user.shopName} />}</StaffLayout>;
}